import ProfileIcon from '../../assets/icons/profile.svg?react';
import { Modal } from '../UI';
import { Button } from '../UI/base/Button';
import styles from './PatientWarningModal.module.css';

interface PatientWarningModalProps {
  title: string;
  message: string;
  patientsLabel: string;
  confirmLabel: string;
  cancelLabel: string;
  patientNames: string[];
  onClose: () => void;
  onConfirm: () => void;
}

export const PatientWarningModal = ({
  title,
  message,
  patientsLabel,
  confirmLabel,
  cancelLabel,
  patientNames,
  onClose,
  onConfirm
}: PatientWarningModalProps) => {
  return (
    <Modal
      title={title}
      onClose={onClose}
      style={{ width: 568 }}
      contentStyle={{ padding: '0 24px', gap: 0 }}
      headerStyle={{
        padding: 'var(--padding-xl) var(--padding-2xl) var(--padding-base) var(--padding-2xl)'
      }}
      footer={
        <div className={styles.footer}>
          <Button type="secondary" onClick={onClose}>
            {cancelLabel}
          </Button>
          <Button type="primary" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      }
    >
      <div className={styles.warningRow}>
        <span className={styles.warningMessage}>{message}</span>
      </div>
      <p className={styles.patientsLabel}>{patientsLabel}</p>
      <ul className={styles.patientList}>
        {patientNames.map((name) => (
          <li key={name} className={styles.patientItem}>
            <ProfileIcon />
            {name}
          </li>
        ))}
      </ul>
    </Modal>
  );
};
